<ng-container *ngIf="token != null">
    <div id="token-editor">
        <div class="token-resize left" (pointerdown)="beginResize($event)" (pointermove)="resize($event)" (pointerup)="endResize($event)">
            <img src="./assets/resize-arrow.png" draggable="false" />
        </div>
        <div id="token-rotate" (pointerdown)="beginRotate($event)" (pointermove)="rotate($event)" (pointerup)="endRotate($event)">
            <img src="./assets/rotate-arrow.png" draggable="false" />
        </div>
        <div id="token-panel">
            <div class="token-values">
                <div class="token-value">
                    <label>Health</label>
                    <input type="number" [(ngModel)]="token.data.health" (input)="update(token)" (keydown)="keydown($event)" />
                </div>
                <div class="token-value">
                    <label>Max Health</label>
                    <input type="number" [(ngModel)]="token.data.maxhealth" (input)="update(token)" (keydown)="keydown($event)" />
                </div>
                <div class="token-value">
                    <label>Armor</label>
                    <input type="number" [(ngModel)]="token.data.armor" (input)="update(token)" (keydown)="keydown($event)" />
                </div>
                <div class="token-value token-button" (click)="copy(token)">
                    <label>Copy</label>
                    <mat-icon>file_copy</mat-icon>
                </div>
            </div>
            <div class="token-values" style="margin-top: 6px;">
                <div class="token-value" id="token-label">
                    <label>Label</label>
                    <input maxlength="25" value="" [(ngModel)]="token.data.label" (input)="update(token)" (keydown)="keydown($event)" />
                </div>
                <div class="token-value  token-button" (click)="toggleVisibility(token)">
                    <label>Visibility</label>
                    <mat-icon *ngIf="token.data.visible==true">visibility</mat-icon>
                    <mat-icon *ngIf="token.data.visible==false">visibility_off</mat-icon>
                </div>
            </div>
        </div>
    </div>
</ng-container>